import { render, staticRenderFns } from "./TeaserSkeleton.html?vue&type=template&id=0d161faa&"
import script from "./TeaserSkeleton.vue?vue&type=script&lang=js&"
export * from "./TeaserSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./TeaserSkeleton.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports